import * as React from "react";
import { DefaultStyles } from "./styles";
import { Location } from '../googlemaps/location';
import { Map as GoogleMap } from '../googlemaps/map';
import { Control as MapControl } from '../googlemaps/control';
import { ControlPosition as MapControlPosition } from '../googlemaps/util';

interface BaseMapProps extends React.HTMLAttributes<HTMLDivElement> {
    center?: Location
    zoom?: number;
    styles?: google.maps.MapTypeStyle[];
    onClose?: () => void;
    children?: (map: google.maps.Map) => React.ReactNode;
}

interface BaseMapState {

}

const defaultProps = {
    styles: DefaultStyles,
};

const UIControl: React.FC<React.HTMLAttributes<HTMLDivElement>> = props => {

    const {
        style,
        ...other
    } = props;

    return (<div style={
        {
            backgroundColor: "#fff",
            marginTop: '10px',
            marginLeft: '10px',
            height: '40px',
            borderRadius: '2px',
            boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 4px - 1px',
            cursor: 'pointer',
            marginBottom: '10px',
            textAlign: 'center',
            ...style
        }} {...other} >{props.children}</ div>)
}
UIControl.displayName = "Map.BaseMap.UIControl";

const TextControl: React.FC<React.HtmlHTMLAttributes<HTMLDivElement>> = props => {
    const {
        style,
        ...other
    } = props;
    return (<div style={
        {
            color: 'rgb(0, 0, 0)',
            fontFamily: 'Roboto, Arial, sans-serif',
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '38px',
            paddingTop: '2px',
            paddingLeft: '10px',
            paddingRight: '10px',
            ...style
        }} {...other} >{props.children}</ div>)
}
TextControl.displayName = "Map.BaseMap.TextControl";

export const BaseMap: React.ComponentType<BaseMapProps> = class extends React.PureComponent<BaseMapProps, BaseMapState>{

    static defaultProps = defaultProps;

    private readonly closeControl =
        <UIControl title={'Close Map'} onClick={() => this.props.onClose && this.props.onClose()} style={{ marginRight: '10px', width: '40px' }}>
            <TextControl>
                <i className="fa fa-times"></i>
            </TextControl>
        </UIControl>


    render() {
        const {
            center,
            zoom,
            styles,
            onClose,
            ...divProps
        } = this.props;

        return <GoogleMap options={{
            center, zoom, styles,
            zoomControlOptions: { position: MapControlPosition.RIGHT_TOP },
            streetViewControlOptions: { position: MapControlPosition.RIGHT_TOP },
        }}
            {...divProps}
        >
            {(map) =>
                <>
                    {this.props.onClose && <MapControl map={map} position={MapControlPosition.TOP_RIGHT} content={this.closeControl} />}
                    {this.props.children && this.props.children(map)}
                </>
            }
        </GoogleMap>
    }
}